(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-sub-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  const getComparableCardURL = (url) => {
    const comparableURL = new URL(url.toString());
    comparableURL.hash = '';

    const params = new URLSearchParams(comparableURL.search);
    params.sort();
    comparableURL.search = params.toString();

    return comparableURL.pathname + (comparableURL.search ? '?' + comparableURL.search : '');
  };

  const syncSelectedShowcaseCard = () => {
    const currentComparableURL = getComparableCardURL(new URL(window.location.href));

    document.querySelectorAll('.sub-collection-showcase__card[href]').forEach((card) => {
      if (!(card instanceof HTMLAnchorElement)) return;

      const isSelected = getComparableCardURL(new URL(card.href, window.location.origin)) === currentComparableURL;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-current', isSelected ? 'page' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const card = event.target instanceof Element ? event.target.closest('.sub-collection-showcase__card[href]') : null;
    if (!(card instanceof HTMLAnchorElement)) return;

    const targetURL = new URL(card.href, window.location.origin);
    const currentURL = new URL(window.location.href);

    if (targetURL.pathname !== currentURL.pathname || !targetURL.search) return;

    const facetsForm = document.querySelector('facets-form-component');
    const productGrid = document.querySelector('#sub-collection-showcase__grid');

    if (!facetsForm || !productGrid || typeof facetsForm.updateFiltersByURL !== 'function') return;

    event.preventDefault();
    facetsForm.updateFiltersByURL(targetURL.toString());
    syncSelectedShowcaseCard();

    const headerHeightValue = getComputedStyle(document.body).getPropertyValue('--header-height').trim();
    const headerHeight = Number.parseFloat(headerHeightValue) || 0;
    const scrollTop = window.scrollY + productGrid.getBoundingClientRect().top - headerHeight;

    window.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
  });

  document.addEventListener('DOMContentLoaded', syncSelectedShowcaseCard, { once: true });
  window.addEventListener('popstate', syncSelectedShowcaseCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
